import styled from 'styled-components'

export const MainContainer = styled.div<{ disabled: boolean }>`
  position: relative;
  .filter-icon {
    width: 16px;
    height: 16px;
    position: absolute;
    top: 50%;
    left: 12px;
    transform: translateY(-50%);
    pointer-events: none;
    ${({ disabled }) => disabled && `opacity: 0.3;`}
  }
  .filter-input {
    width: 100%;
    height: 48px;
    padding-left: 40px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    font-family: Inter;
    font-weight: 500;
    font-size: 14px;
    color: #757575;
    max-width: 180px;
    border: 1px solid
      ${({ disabled }) =>
        disabled ? '#CCCCCC' : 'var(--preto-principal, #1c1d22)'};
    border-radius: 5px;
    outline: none;
    background: transparent;
  }
  .filter-input:disabled {
    border-color: #cccccc;
    color: #cccccc;
  }
  .filter-input:disabled::placeholder {
    color: #cccccc;
  }
  .chrevon-down {
    width: 16px;
    height: 16px;
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    pointer-events: none;
    ${({ disabled }) => disabled && `opacity: 0.3;`}
  }
  .menu {
    position: absolute;
    top: 52px;
    left: 0;
    width: 100%;
    z-index: 999;
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #fff;
  }
  .menu::-webkit-scrollbar {
    width: 8px;
    background-color: #c4c4c4;
    border-radius: 50px;
  }
  .menu::-webkit-scrollbar-track {
    background: #fbfbfb;
    border: 0;
  }
  .menu::-webkit-scrollbar-thumb {
    width: 8px;
    background-color: #c4c4c4;
    border-radius: 50px;
  }
`
export const Option = styled.button<{ isSelected: boolean }>`
  padding: 8px 10px;
  font-size: 12px;
  color: #1c1d22;
  font-weight: 500;
  background-color: #fff;
  border: none;
  outline: none;
  width: 100%;
  text-align: left;
  font-family: Inter;
  display: flex;
  flex-direction: row;
  cursor: pointer;
  background-color: ${({ isSelected, theme }: any & { theme: any }) =>
    isSelected ? theme.colors.toggleHover : '#fff'};
  &:hover {
    background-color: ${({ isSelected, theme }: any & { theme: any }) =>
      isSelected ? theme.colors.toggleHover : theme.colors.toggleUnselected};
  }
`
export const Checkbox = styled.label`
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  user-select: none;
  input.original-checkbox {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .custom-checkbox {
    position: relative;
    height: 18px;
    width: 18px;
    background-color: #fff;
    border: 2px solid #ddd;
    border-radius: 3px;
    margin-right: 8px;
  }
  input.original-checkbox:checked ~ .custom-checkbox {
    background-color: #df7a58;
    border-color: #df7a58;
  }
  .custom-checkbox:after {
    content: '';
    position: absolute;
    display: none;
    left: 3px;
    top: -1px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
  input.original-checkbox:checked ~ .custom-checkbox:after {
    display: block;
  }
`
